import * as Sentry from 'expose-loader?exposes=Sentry!@sentry/browser'
import isIn from 'shared/fp/isIn'
import {
  COMMUNITY_COMMON_IGNORED_RULES,
  COMMUNITY_COMMON_IGNORED_URLS,
} from './commonJavascriptRules'
import TRACKER_DOMAINS from './trackerDomains'

if (process.env.RAILS_ENV !== 'development') {
  Sentry.init({
    dsn: 'https://853459f106d4445b83fdb8ce391e38b6@sentry.io/35119',
    environment: process.env.RAILS_ENV,
    tags: { environment: process.env.RAILS_ENV },
    denyUrls: [
      ...COMMUNITY_COMMON_IGNORED_URLS,
      ...TRACKER_DOMAINS.map(domain => new RegExp(domain |> escapeRegExp)),
    ],
    ignoreErrors: [
      ...COMMUNITY_COMMON_IGNORED_RULES,
      'AbortError: The Internet connection appears to be offline.',
      'AbortError: The network connection was lost.',
      'AbortError: The operation was aborted.',
      'AbortError: The user aborted a request.',
      'Error: AbortError: The user aborted a request.',
      'Error: Network error: cancelled',
      'Error: Network error: The network connection was lost.',
      'FetchError: Error 400 - Bad Request',
      'FetchError: Error 503 - Service Temporarily Unavailable',
      'Network error: Failed to fetch',
      'Network error: Load failed',
      'TypeError: annullato',
      'TypeError: cancelado',
      'TypeError: cancelled',
      'TypeError: Failed to fetch',
      'TypeError: Load failed',
      'TypeError: NetworkError when attempting to fetch resource.',
      'TypeError: The Internet connection appears to be offline.',
      'TypeError: The network connection was lost.',
      'TypeError: The operation was aborted.',
      "TypeError: Failed to execute 'getBattery' on 'Navigator': Illegal invocation", // Bazaarvoice script error...
      'Object Not Found Matching Id:',
    ],
    beforeBreadcrumb(breadcrumb, hint) {
      try {
        if (
          breadcrumb.type === 'http' &&
          (breadcrumb.category |> isIn(['xhr', 'fetch']))
        ) {
          const { host } = new URL(
            breadcrumb.data.url,
            `${window.location.protocol}//${window.location.host}`
          )
          if (
            TRACKER_DOMAINS.some(ignoredDomain =>
              isSubDomainOf(ignoredDomain, host)
            )
          ) {
            return null
          }
          if (
            breadcrumb.data.method === 'POST' &&
            breadcrumb.data.url === '/api/v3/segment_io'
          ) {
            return null
          }
        }
        return breadcrumb
      } catch (e) {
        console.error(e)
        return breadcrumb
      }
    },
  })
}

function isSubDomainOf(domain, host) {
  return host.endsWith('.' + domain) || host === domain
}

function escapeRegExp(string) {
  return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')
}
